import { includes } from 'lodash';
import store from '../../app/stores/store';

export const verifyToken = () => {
    const token = localStorage.getItem('token');
    const accessDate = +localStorage.getItem('accessDate');
    const ttl = +localStorage.getItem('ttl');
    const limit = accessDate + (ttl * 1000);

    return token && Date.now() < limit;
};

export const inPrivateRoute = location => {
    const publicRoutes = [
        '/signin/admin/check-username',
        '/signin/admin/reset-password-code',
        '/signin/admin/reset-password',
        '/signin/admin',
        '/signin/check-username',
        '/signin/reset-password-code',
        '/signin/reset-password',
        '/signin',
    ];

    return !includes(publicRoutes, location);
};

export const inResetPasswordFormRoute = location => {
    const passwordResetRoutes = [
        '/signin/admin/reset-password',
        '/signin/reset-password'
    ];

    return includes(passwordResetRoutes, location);
};

export const securityCodeExistance = () => store.getState().auth.passwordReset.securityCode;
